// extracted by mini-css-extract-plugin
export default {"portalPopupOverlay":"PortalPopup_portalPopupOverlay__sFLcr"};